import { render, staticRenderFns } from "./RwStopEdit.vue?vue&type=template&id=48649b51&"
import script from "./RwStopEdit.vue?vue&type=script&lang=ts&"
export * from "./RwStopEdit.vue?vue&type=script&lang=ts&"
import style0 from "./RwStopEdit.vue?vue&type=style&index=0&id=48649b51&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports